import { render } from "./TextMarkersConfig.vue?vue&type=template&id=6fe266a0&scoped=true"
import script from "./TextMarkersConfig.vue?vue&type=script&lang=js"
export * from "./TextMarkersConfig.vue?vue&type=script&lang=js"

import "./TextMarkersConfig.vue?vue&type=style&index=0&id=6fe266a0&scoped=true&lang=css"

import exportComponent from "/dev/shm/repo/airmap-2s5z7ythbr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe266a0"]])

export default __exports__